import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { LogOutIcon, UserIcon, BellIcon } from 'lucide-react';
const Header: React.FC = () => {
  const {
    user,
    logout
  } = useAuth();
  return <header className="bg-white shadow-sm z-10" data-id="element-399">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-400">
        <div className="flex justify-between h-16" data-id="element-401">
          <div className="flex items-center" data-id="element-402">
            <h1 className="text-xl font-semibold text-gray-800" data-id="element-403">
              Energy Meter Dashboard
            </h1>
          </div>
          <div className="flex items-center space-x-4" data-id="element-404">
            <div className="relative" data-id="element-405">
              <button className="p-1 rounded-full text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-406">
                <BellIcon className="h-6 w-6" data-id="element-407" />
                <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500" data-id="element-408"></span>
              </button>
            </div>
            <div className="flex items-center" data-id="element-409">
              <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-600 text-white" data-id="element-410">
                <UserIcon className="h-5 w-5" data-id="element-411" />
              </div>
              <span className="ml-2 text-sm font-medium text-gray-700" data-id="element-412">
                {user?.name} ({user?.role})
              </span>
            </div>
            <button onClick={logout} className="flex items-center text-sm text-gray-700 hover:text-gray-900" data-id="element-413">
              <LogOutIcon className="h-5 w-5 mr-1" data-id="element-414" />
              <span data-id="element-415">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;